/* istanbul ignore next */
export const ADD_TO_CART_MESSAGES_ID = 'ADD_TO_CART_MESSAGES_ID';
/* istanbul ignore next */
export const ADD_TO_CART_COMMON_MESSAGE_ID = 'ADD_TO_CART_COMMON_MESSAGE_ID';

export const BUTTON_TYPE = ['Default', 'Primary', 'Secondary', 'Tertiary', 'Text', 'Link'];
